module.exports = __webpack_public_path__ + "static/media/profileIcon.c7730c57.svg";